import styled from 'styled-components';

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    margin: auto;
    width: 100%;

    h1 {    
        font-size: 2rem;
        margin: 0;
    }
`;